/**
 * Constants for refresh actions (Refresh Selected, Refresh Sheet Options)
 */

export const MAX_ITEMS_PER_RUN = 250;
export const CONFIRM_THRESHOLD = 50;
export const REQUESTS_PER_SECOND = 7;
export const JITTER_MS_MAX = 80;
